// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const fr = {
  Hi: "Salut",
  Description: "Besoin d'aide?\n Veuillez consulter nos documents.",
  Documentation: "Documentation",
  EnglishLevel: "Niveau d'anglais",
  FrenchLevel: "Niveau de francais",
  EnglishExam: "Examen d'anglais",
  FrenchExam: "Examen de Français",
  ExamType: "Type d'examen",
  Score: "Score",
  ReadingScore: "Note de lecture",
  WritingScore: "Note d'écriture",
  ListeningScore: "Note d'écoute",
  SpeakingScore: "Note orale",
  ExamDate: "Date de l'examen",
  Yes: "Oui",
  Applicant: "Demandeur",
  Mother: "Mère",
  Father: "Père",
  Brothers: "Frères",
  Sisters: "Sœurs",
  Children: "Enfants",
  Education: "Éducation",
  Relations: "Rapports",
  Languages: "Langues",
  Experience: "Vivre",
  Activities: "Activités",
  Addresses: "Adresses",
  Travels: "Voyages",
  Passports: "Passeports",
  OtherInformation: "Autre",
  DateofDeath: "Date de décès",
  ApplyForVisaCanadaBefore: "Avez-vous ou l'un des membres de votre famille déjà demandé un visa canadien? (Touristique, résidentiel, travail, éducation, etc.) ?",
  VisaCanadaRejectedBefore: "Est-ce que vous ou un membre de votre famille avez déjà vu une demande de visa pour le Canada ou un autre pays rejetée?",
  ReportedExperience: "Est-ce que vous ou l'un des membres de votre famille avez déjà été expulsé du Canada ou de tout autre pays ?",
  ModifiedDate: "Date modifiée",
  SaveChanges: "Sauvegarder les modifications",
  OveralExamScore: "Note globale de l'examen",
  ExpireDate: "Date d'expiration",
  SelectYourLevel: "Sélectionnez votre niveau",
  DidYouHaveExam: "Avez-vous passé un examen ?",
  WitchExam: "Examen de sorcière ?",
  SelectLanguage: "Choisir la langue",
  AsylumApplied: "Avez-vous, ou l'un des membres de votre famille, déjà demandé l'asile au Canada ou dans tout autre pays?",
  ArrestedBefore: "Est-ce que vous ou l'un des membres de votre famille avez déjà commis un crime ou été arrêté ?",
  HealthCareBefore: "En plus de prendre des médicaments, est-ce que vous ou un membre de votre famille avez besoin de l'aide de fournisseurs de soins de santé pendant votre séjour au Canada?",
  StayLongerThanVisa: "Est-ce que vous ou un membre de votre famille avez séjourné au Canada ou dans un autre pays plus longtemps que la validité de votre visa ?",
  TerroristHistory: "Est-ce que vous ou un membre de votre famille avez des antécédents d'implication dans des groupes politiques ou des groupes terroristes, etc.",
  SecurityProblems:
    "Veuillez expliquer en détail si vous ou l'un des membres de votre famille avez des antécédents de faute professionnelle, de problèmes de sécurité ou d'action antérieure liée à un visa depuis le Canada ou tout autre pays.",
  No: "Non",
  Expert: "Expert",
  VeryGood: "Très bien",
  Good: "Bien",
  Competent: "Compétent",
  Modest: "Modeste",
  Limited: "Limité",
  None: "Aucun",
  IELTSGeneral: "IELTS général",
  IELTSAcademic: "IELTS Académique",
  CELPIPG: "CELPIP-G",
  TEF: "TEF",
  CELPIP: "CELPIP",
  Gender: "Le genre",
  FirstName: "Prénom",
  LastName: "Nom de famille",
  FirstNameNativeLanguage: "Prénom (langue maternelle)",
  LastNameNativeLanguage: "Nom de famille (langue maternelle)",
  FirstNameEnglish: "Prénom (anglais)",
  LastNameEnglish: "Nom de famille (anglais)",
  DateofBirth: "Date de naissance",
  Height: "Hauteur",
  EyeColor: "Couleur des yeux",
  CityofBirth: "Ville de naissance",
  CountryofBirth: "Pays de naissance",
  DeathDate: "Date de mort",
  CityofDeath: "Ville de la mort",
  CountryofDeath: "Pays de mort",
  PostalCode: "code postal",
  JobTitle: "Titre d'emploi",
  Company: "Compagnie",
  Email: "E-mail",
  MaritalStatus: "État civil",
  ChildNumber: "Numéro d'enfant",
  DateofMarriage: "Date du mariage",
  DateofDivorce: "Date du divorce",
  Address: "Adresse",
  NetWorth: "Valeur nette",
  EducationLevel: "niveau d'éducation",
  EducationMajor: "Master en éducation",
  MoreAboutEducation: "En savoir plus sur l'éducation",
  WorkExperince: "Expérience de travail",
  WorkType: "Type de travail",
  MoreAboutWork: "En savoir plus sur le travail",
  PleaseExplainAboutYourEducationHistory: "Veuillez expliquer votre parcours scolaire",
  PleaseExplainAboutYourJobHistory: "Veuillez expliquer votre historique de travail",
  General: "Général",
  Profile: "Profil",
  AssessmentForm: "Formulaire d'évaluation",
  SocialLinks: "Liens sociaux",
  ChangePassword: "Changer le mot de passe",
  AccountSettings: "Paramètres du compte",
  Account: "Compte",
  ClientsEvaluated: "Clients évalués",
  ImmigrationCases: "Cas d'immigration",
  TotalPosts: "Nombre total de messages",
  About: "À propos de",
  LiveAt: "Vivre à &nbsp",
  YouAreAssessed: "évaluera vos informations",
  AssessingYou: "Vous évaluer",
  AssessMe: "Évaluez-moi",
  HasAccessDocuments: "a accès à vos documents",
  DisconnectAccess: "Déconnecter l'accès",
  DocumentAccess: "Accès aux documents",
  Password: "Mot de passe",
  App: "Application",
  user: "utilisateur",
  List: "Liste",
  Edit: "Éditer",
  Shop: "Boutique",
  Blog: "Blog",
  Mail: "Courrier",
  Chat: "Discuter",
  Cards: "Cartes",
  Posts: "Des postes",
  Create: "Créer",
  Banking: "Bancaire",
  Booking: "Réservation",
  Product: "Produit",
  Invoice: "Facture d'achat",
  Details: "Détails",
  Checkout: "Vérifier",
  Calendar: "Calendrier",
  Analytics: "Analytique",
  Ecommerce: "Commerce électronique",
  Management: "Gestion de compte",
  Menu: "Menu",
  Item_disabled: "Élément désactivé",
  Item_label: "Libellé de l'article",
  Item_caption: "Légende de l'article",
  Other_cases: "Autres cas",
  Item_by_roles: "Élément par rôles",
  Only_admin_can_see_this_item: "Seul l'administrateur peut voir cet élément",
  TotalElementarySchool: "Nombre total d'années d'études primaires",
  TotalMiddleSchool: "Nombre total d'années d'études secondaires",
  TotalHighSchool: "Nombre total d'années d'études secondaires",
  TotalPreUniversity: "Nombre total d'années d'études préuniversitaires",
  TotalAssociate: "Total des années académiques du diplôme d'associé",
  TotalUndergraduate: "Nombre total d'années d'études de premier cycle",
  TotalMaster: "Nombre total d'années d'études pour le master",
  TotalDoctoral: "Nombre total d'années d'études doctorales",
  TotalProfessional: "Années académiques techniques et professionnelles totales",
  Organization: "Organisme",
  Degree: "Diplôme",
  Major: "Principal",
  SelectType: "Sélectionner le genre",
  StartDate: "Date de début",
  EndDate: "Date de fin",
  City: "Ville",
  Country: "Pays",
  Relation: "Relation",
  CityofResidence: "Ville de résidence",
  ProvinceofResidence: "Province de résidence",
  ActivityType: "Type d'activité",
  ActivityLocation: "Lieu de l'activité",
  License: "Licence",
  MoreInformation: "Plus d'information",
  PassportNumber: "Numéro de passeport",
  IssueDate: "Date d'émission",
  ExpiryDate: "Date d'expiration",
  DayPerWeek: "Jour par semaine",
  HourPerDay: "Heure par jour",
  CompanyPhone: "Téléphone de l'entreprise",
  CEOName: "Nom du PDG",
  CEOPhoneNumber: "Numéro de téléphone du PDG",
  YourManagerName: "Nom de votre gestionnaire",
  YourManagerTitle: "Votre titre de gestionnaire",
  YourManagerPhoneNumber: "Numéro de téléphone de votre responsable",
  CompanyPostalCode: "Code postal de l'entreprise",
  ActivityLocationHelper: "",
  FullTime: "À plein temps",
  PartTime: "À temps partiel",
  Citizen: "Citoyen",
  PermanentResidence: "Résidence permanente",
  TemporaryResidence: "Résidence temporaire",
  StatusinCanada: "Statut au Canada",
  Spouse: "Conjoint",
  Background: "Arrière plan",
  Documents: "Documents",
  Questioner: "Questionnaire",
  Personal: "Personnel",
  PersonalPhoto: "",
  InformationAboutPersonalPhoto: "Informations sur la photo personnelle",
  UploadFile: "Téléverser un fichier",
  PrintTime: "Temps d'impression",
  TranslationDateIfTranslated: "Date de traduction (si traduit)",
  NationalID: "carte d'identité",
  MilitaryServiceLicense: "Licence de service militaire",
  PhotocopyMarriageCertificate: "Photocopie de la licence/certificat de mariage",
  IDCard: "Carte d'identité",
  PhotocopyDivorceDocuments: "Photocopie des documents de divorce",
  NumberofChildren: "Nombre d'enfants",
  Consultants: "Conseillers",
  MyAccount: "Mon compte",
  consultant: "Consultant",
  applicant: "Demandeur",
  ShareWhatThinkingAbout: "Partagez ce que vous pensez",
  Post: "Poste",
  Logout: "Se déconnecter",
  Home: "Maison",
  Beta: "Bêta",
  SignUp: "S'inscrire",
  Dashboard: "Tableau de bord",
  Pages: "pages",
  Other: "Autre",
  AboutUs: "À propos de nous",
  ContactUs: "Nous contacter",
  Pricing: "Tarification",
  Login: "Connexion",
  Register: "S'inscrire",
  ResetPassword: "réinitialiser le mot de passe",
  WriteComment: "Écrire un commentaire…",
  Authentication: "Authentification",
  SortBy: "Trier par",
  Name: "Nom",
  Applicants: "Candidats",
  Immigrationfromhereto: "Immigration d'ici à",
  Canada: "Canada",
  BetterProbroadimmigrationplatform: "BetterPro est une vaste plateforme d'immigration qui permet aux immigrants et aux consultants de se trouver et de rester en contact",
  GetStarted: "Commencer",
  HowBetterProHelpYou: "Comment BetterPro vous aide-t-il ?",
  ServicesForConsultants: "Services spéciaux pour consultants",
  Questionnaire: "Questionnaire",
  CollectInformationAboutClients:
    "Recueillir des informations sur les clients, telles que leurs informations personnelles, leur travail, leurs études, etc., et remplir les formulaires d'immigration avec ces informations",
  CollectingDocuments: "Collecte de documents",
  GatherDocumentsfromApplicants: "Rassemblez les documents des demandeurs de manière catégorisée en fonction des besoins de chaque cas d'immigration.",
  SafeCommunication: "Communication sécurisée",
  ConsultantsApplicantsCommunicate:
    "Les consultants en immigration et les candidats peuvent communiquer via BetterPro à toutes les étapes du processus d'immigration (de l'évaluation initiale à l'obtention d'un visa",
  ProfilePage: "Page de profil",
  HavinguptodateProfiles: "Avoir des profils à jour dans plusieurs langues vous aidera à attirer plus de clients",
  PlansCustomized: "Des forfaits personnalisables",
  ToMeetYourNeeds: "pour répondre aux besoins de votre entreprise",
  MakeModernOnline: "Faites de votre entreprise en ligne moderne un succès en choisissant un plan",
  PlusTaxes: " * Taxes applicables en sus",
  mo: "/mois",
  POPULAR: "POPULAIRE",
  Basic: "de base",
  ThirtyDaysTrial: "30 jours d'essai / Aucune carte de crédit requise",
  SixtyDaysTrial: "Essai de 60 jours / Aucune carte de crédit requise",
  NinetyDaysTrial: "Essai de 90 jours / Aucune carte de crédit requise",
  MultilanguageProfile: "Profil multilingue",
  Blogging: "Bloguer",
  AccessToLeads: "Accès aux prospects",
  ComminicateWithClients: "Communiquer avec les clients",
  FullSupport: "Plein soutien",
  Starter: "Entrée",
  Premium: "Prime",
  ChoosePremium: "Choisissez Premium",
  ChooseStarter: "Choisissez le démarreur",
  ChooseBasic: "Choisissez de base",
  GetStartedWith: "Commencez avec",
  BetterProPlatformToday: "La plateforme BetterPro aujourd'hui",
  WhereFindUs: "Où nous trouver?",
  FeelFreeContactUs: "N'hésitez pas à nous contacter.",
  WeGladHearFromYou: "Nous serons heureux de vous entendre.",
  ToShareYourComment: "Pour partager votre commentaire sur",
  PleaseSignup: "Inscrivez vous s'il vous plait",
  IAmConsultant: "Je suis consultant/avocat en immigration",
  IAmImmigrate: "J'ai l'intention d'immigrer au Canada",
  SelectBestOption: "Sélectionnez la meilleure option",
  AlreadyHaveAccount: "Vous avez déjà un compte?",
  BroadImmigrationPlatformBetterPro: "Large plateforme d'immigration avec BetterPro",
  GetStartedFree: "Commencez tout à fait gratuitement.",
  NoCreditNeeded: "Aucune carte de crédit nécessaire.",
  DontHaveAccount: "Vous n'avez pas de compte ?",
  EnterDetails: "Entrez vos coordonnées ci-dessous.",
  WelcomeBack: "Salut, bienvenue à nouveau",
  RememberMe: "Souviens-toi de moi",
  ForgotPassword: "Mot de passe oublié?",

  FieldofStudy: "Field of Study",
  TypeofWork: "Type of Work",
  AnnulledMarriage: "Annulled Marriage",
  CommonLaw: "Common-Law",
  DivorcedSeparated: "Divorced / Separated",
  LegallySeparated: "Legally Separated",
  Married: "Married",
  NeverMarriedSingle: "Never Married / Single",
  Widowed: "Widowed",
  RegisterSaveInformation: "Inscrivez-vous pour enregistrer les informations et recevoir les messages des consultants",
  AssessmentForm: "َAssessment Form",
  UserName: "User Name",
  BlogPosts: "Blog Posts",
  NotProfileLanguage: "Consultant does not have a profile for this language. Please select another language.",
  Services: "Services",
  ContactInfo: "Contact Info (Please let the consultant know how best to contact you)",
  PhoneNumber: "Phone Number",
};

export default fr;
